export default __webpack_public_path__ + "static/media/Mercenary's Helm of Stalking Fury.c9b67c28.jpg";